module.exports = __webpack_public_path__ + "static/media/home-wheel-loaders.a2c547ce.jpg";